import { render, staticRenderFns } from "./payment-plans-table.vue?vue&type=template&id=0afdb290&scoped=true"
import script from "./payment-plans-table.vue?vue&type=script&lang=js"
export * from "./payment-plans-table.vue?vue&type=script&lang=js"
import style0 from "./payment-plans-table.vue?vue&type=style&index=0&id=0afdb290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afdb290",
  null
  
)

export default component.exports